import './light-footer.scss';

interface ILightFooter {
  children: React.ReactNode;
}

export default function LightFooter({ children }: ILightFooter) {
  return <div className="light-footer">{children}</div>;
}
